import { render, staticRenderFns } from "./PollNumberEditorValue.vue?vue&type=template&id=52265e1a&scoped=true"
import script from "./PollNumberEditorValue.vue?vue&type=script&lang=js"
export * from "./PollNumberEditorValue.vue?vue&type=script&lang=js"
import style0 from "./PollNumberEditorValue.vue?vue&type=style&index=0&id=52265e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52265e1a",
  null
  
)

export default component.exports